(function($R)
{
    $R.lang['no'] = {
        "format": "Format",
        "image": "Bilde",
        "file": "Fil",
        "link": "Link",
        "bold": "Fet",
        "italic": "Kursiv",
        "deleted": "Gjennomstreking",
        "underline": "Understreking",
        "superscript": "Superscript",
        "subscript": "Subscript",
        "bold-abbr": "F",
        "italic-abbr": "K",
        "deleted-abbr": "S",
        "underline-abbr": "U",
        "superscript-abbr": "Sup",
        "subscript-abbr": "Sub",
        "lists": "Punkt",
        "link-insert": "Sett inn link",
        "link-edit": "Rediger link",
        "link-in-new-tab": "Åpne link i ny fane",
        "unlink": "Fjern Understreking",
        "cancel": "Abryt",
        "close": "Lukk",
        "insert": "Sett inn",
        "save": "Lagre",
        "delete": "Slett",
        "text": "Tekst",
        "edit": "Rediger",
        "title": "Tittel",
        "paragraph": "Normal tekst",
        "quote": "Sitat",
        "code": "Kode",
        "heading1": "Overskrift 1",
        "heading2": "Overskrift 2",
        "heading3": "Overskrift 3",
        "heading4": "Overskrift 4",
        "heading5": "Overskrift 5",
        "heading6": "Overskrift 6",
        "filename": "Navn",
        "optional": "valgfri",
        "unorderedlist": "Unordered List",
        "orderedlist": "Punktliste",
        "outdent": "Reduser innrykk",
        "indent": "Øk innrykk",
        "horizontalrule": "Linje",
        "upload": "Upload",
        "upload-label": "Drop files here or click to upload",
        "upload-change-label": "Drop a new image to change",
        "accessibility-help-label": "Rik-tekst behandler",
        "caption": "Bildetekst",
        "bulletslist": "Punkter",
        "numberslist": "Nummerering",
        "image-position": "Posisjon",
        "none": "Ingen",
        "left": "Venstre",
        "right": "Høgre",
        "center": "Senter",
        "undo": "Undo",
        "redo": "Redo"
    };
})(Redactor);